import { configureStore } from "@reduxjs/toolkit";
import filterReducer from "./slices/filterSlice";
import homeReducer from "./slices/homeSlice";
import reportReducer from "./slices/reportSlice";
import moduleReducer from "./slices/moduleSlice";

export const store = configureStore({
  reducer: {
    filters: filterReducer,
    home: homeReducer,
    report: reportReducer,
    module: moduleReducer,
  },
});